import * as api from '../register_api_services/SnECertificate.api';

export const getCertificateTypes = () => {
  return async () => {
    try {
      const data = await api.fetchCertificateTypes();
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const createCertificateType = (certificate_type) => {
  return async () => {
    try {
      const data = await api.createCertificateTypeApi(certificate_type);
      return { success: true, message: data?.message || 'Certificate type created.', data };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const updateCertificateType = (id, certificate_type) => {
  return async () => {
    try {
      const data = await api.updateCertificateTypeApi(id, certificate_type);
      return { success: true, message: data?.message || data || 'Certificate type updated.', data };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const deleteCertificateType = (id) => {
  return async () => {
    try {
      const data = await api.deleteCertificateTypeApi(id);
      return { success: true, message: data?.message || 'Certificate type deleted.' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const multiDeleteCertificateTypes = (ids) => {
  return async () => {
    try {
      const data = await api.multiDeleteCertificateTypesApi(ids);
      return { success: true, message: data?.message || 'Certificate types deleted.' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const getSnECertificates = (client_id, certificate_type = 'sne') => {
  return async () => {
    try {
      const data = await api.fetchSnECertificates(client_id, certificate_type);
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const uploadSnECertificate = (payload) => {
  return async () => {
    try {
      const data = await api.uploadSnECertificateApi(payload);
      const ok = data?.success === true;
      const message =
        (typeof data?.message === 'object' && data.message?.message) ||
        (typeof data?.message === 'string' && data.message) ||
        'Certificate uploaded successfully.';
      return { success: ok, message, data };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const updateSnECertificate = (id, payload) => {
  return async () => {
    try {
      const data = await api.updateSnECertificateApi(id, payload);
      return { success: true, message: data?.message || 'Updated successfully.', data };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const deleteSnECertificate = (id) => {
  return async () => {
    try {
      const data = await api.deleteSnECertificateApi(id);
      return { success: true, message: data?.message || 'Deleted successfully.' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const downloadSnECertificate = (id) => {
  return async () => {
    try {
      await api.downloadSnECertificateApi(id);
      return { success: true, message: 'Download started.' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const viewSnECertificate = (id) => {
  return async () => {
    try {
      const result = await api.viewSnECertificateApi(id);
      return { success: true, blob: result.blob, message: 'PDF loaded.' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};


